import { formattedPrice } from "../../utils"

export const CASH_ERROR_MESSAGE={
    MORE_THEN_BALANCE:  'Cash Amount should not be greater than “Total Amount to be paid” or “Cash Available” value. Please enter a valid amount',
    MORE_THEN_LEGALLY_ALLOWED: 'In line with amendment in Income Tax act, we cannot take more than 2,00,000.00 in cash for any courses from a single student. Kindly choose some other payment mode and proceed.'
}

export const CHEQUE_ERROR_MESSAGES={
PAID_AMOUNT:'The cheque amount cannot be zero. Please enter a positive value or select a different payment method.',
CHEQUE_NUMBER:'Cheque number must be at least 6 digits',
CHEQUE_DATE:'Cheque date cannot be less then one month.',
DUPLICATE_CHEQUE:'The cheque number you entered has already been used. Please enter a different cheque number.',
MORE_THEN_BALANCE:'Paid amount in Cheque should not be greater than or less than Amount to be paid. Please enter a valid amount',
}
export const PDC_HANDLING_MESSAGES={
    PDC_HANDLING: (amount)=>`Extra ${formattedPrice(Math.round(Number(amount)))} will be applied as PDC handling charge`
}

export const CARD_ERROR_MESSAGE={
    MORE_THEN_BALANCE:  'Paid amount in Card should be equal to Amount to be paid. Please enter a valid amount',
    CARD_NUMBER: 'Please Enter last 4 digit of your card number.'
}

export const DD_ERROR_MESSAGES={
    PAID_AMOUNT:'The dd amount cannot be zero. Please enter a positive value or select a different payment method.',
    DD_NUMBER:'DD number must be at least 6 digits',
    DD_DATE:'DD date cannot be less then one month.',
    DUPLICATE_DD:'The dd number you entered has already been used. Please enter a different dd number.',
    MORE_THEN_BALANCE:'Paid amount in DD should not be greater than or less than Amount to be paid. Please enter a valid amount'
    }

export const ADB_ERROR_MESSAGE={
    MORE_THEN_BALANCE:"Balance Amount should not be greater than or less than “Total Amount to be paid” or “Deposit Slip Amount” value. Please enter a valid amount.",
    DUPLICATE_AESL_SLIP:"The AESL slip reference number you selected has already been used. Please enter a different AESL slip reference number"
}

export const ADJ_ERROR_MESSAGE={
    MORE_THEN_BALANCE:"ADJ Amount should not be greater than “Total Amount to be paid” or “ADJ Available” value. Please enter a valid amount"
}

export const CMP_ERROR_MESSAGE={
    MORE_THEN_BALANCE:"CMPR Amount should not be greater than “Total Amount to be paid” or “CMPR Available” value. Please enter a valid amount."
}

export const SDJ_ERROR_MESSAGE={
    MORE_THEN_BALANCE:"SDJ Amount should not be greater than “Total Amount to be paid” or “SDJ Available” value. Please enter a valid amount"
}

export const LOAN_COMMON_ERROR_MESSAGE={
     DUPLICATE_DOID: "The DO ID you selected has already been used. Please enter a different DO ID"
}
export const PRP_ERROR_MESSAGE={
    MORE_THEN_BALANCE: "Loan disbursed Amount should not be greater than or less than “Total Amount to be paid” or “Amount disburded by PRP” value. Please enter a valid amount", 
}

export const EDV_ERROR_MESSAGE={
    MORE_THEN_BALANCE: "Loan disbursed Amount should not be greater than or less than “Total Amount to be paid” or “Amount disburded by EDV” value. Please enter a valid amount",
}

export const BFL_ERROR_MESSAGE={
    MORE_THEN_BALANCE: "Loan disbursed Amount should not be greater than or less than “Total Amount to be paid” or “Amount disburded by BFL” value. Please enter a valid amount",
}
export const GQC_ERROR_MESSAGE={
    MORE_THEN_BALANCE: "Loan disbursed Amount should not be greater than or less than “Total Amount to be paid” or “Amount disburded by GQC” value. Please enter a valid amount",
}
export const JEMI_ERROR_MESSAGE={
    MORE_THEN_BALANCE: "Loan disbursed Amount should not be greater than or less than “Total Amount to be paid” or “Amount disburded by JEMI” value. Please enter a valid amount",
}

export const ONLINE_PAYMENT_ERROR_MESSAGE={
    DUPLICATE_TRANSACTIONID:'The transaction id you entered has already been used. Please enter a different transaction id.',
    MORE_THEN_BALANCE:"Please enter an amount equal to the payable amount of "
}

export const EFT_ERROR_MESSAGE={
    DUPLICATE_TRANSACTIONID:'The transaction id you entered has already been used. Please enter a different transaction id.',
    MORE_THEN_BALANCE:"Please enter an amount equal to the payable amount of "
}
export const JODO_ERROR_MESSAGE={
    DUPLICATE_FLEXID:'The flex id you entered has already been used. Please enter a different flex id.',
    MORE_THEN_BALANCE:"Please enter an amount equal to the payable amount of"
}
export const QRC_ERROR_MESSAGE={
    DUPLICATE_ORDERID:'The order id you entered has already been used. Please enter a different order id.',
    MORE_THEN_BALANCE:"Please enter an amount equal to the payable amount of"
}

export const VOUCHER_ERROR_MESSAGE = {
    MORE_THEN_BALANCE : 'Payments cannot be greater than the amount to be paid. Go to select charges and adjust the amount'
}



